<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="18"
      height="18"
      rx="9"
      fill="#55ACEE"
    />
    <g clip-path="url(#clip0_15_8891)">
      <path
        d="M12.2 6.59998L7.79999 11L5.79999 8.99998"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_8891">
        <rect
          width="8.4"
          height="6"
          fill="white"
          transform="translate(4.79999 6)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
